  const labelPrivilegio = (rol:string)=>{
    let e = ''

    if(rol==='ROLE_ADMIN') e = 'ADMINISTRADOR'
    if(rol==='ROLE_PAGOS') e = 'PAGOS'
    if(rol==='ROLE_GERENTE') e = 'GERENTE'
    if(rol==='ROLE_DEPARTAMENTO') e = 'DEPARTAMENTO'
    if(rol==='ROLE_ASESOR') e = 'ASESOR'
    if(rol==='ROLE_ASISTENTE') e = 'ASISTENTE'
    if(rol==='ROLE_ASEGURADORA') e = 'ASEGURADOR'
    if(rol==='ROLE_VERIFICADOR_TELEFONICO') e = 'VERIFICADOR TELEFÓNICO'
    if(rol==='ROLE_GERENTE_JR') e = 'GERENTE JR'
    if(rol==='ROLE_ADMIN_MESA') e = 'ADMIN MESA'
    if(rol==='ROLE_RECURSOS_HUMANOS') e = 'RECURSOS HUMANOS'
    if(rol==='ROLE_ASESOR_BASE') e = 'ASESOR BASE'
    if(rol==='ROLE_DIRECTOR_COMERCIAL') e = 'DIRECTOR COMERCIAL'

      return e

  }


export default labelPrivilegio;
